import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const notice = {
  notice: {
    name: 'notice',
    theme: '通知公告',
    componentTypes: ['navigate', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'taskNotice/addNotice',
    editFun: 'taskNotice/editNotice',
    getListFun: 'taskNotice/getNoticeList',
    deleteFun: 'taskNotice/deletNotice',
    getDetailFun: 'taskNotice/getNoticeInfo',
    detailPage: [
      {
        buttonName: '发布',
        buttonNames: ['发布', '新增'],
        codes: ['add'],
        name: 'notice',
        type: 'stepForm',
        theme: 'notice',
        step: 'noticeInfo',
        label: '新增通知公告',
        pageStatus: 'add'
      },
      {
        buttonName: '编辑',
        name: 'notice',
        type: 'stepForm',
        theme: 'notice',
        step: 'noticeInfo',
        label: '编辑通知公告',
        checkType: 'checkByUid',
        checkFun: 'taskNotice/getNoticeInfo'
      },
      {
        buttonName: '查看',
        name: 'notice',
        type: 'stepForm',
        theme: 'notice',
        step: 'noticeInfo',
        label: '查看通知公告',
        checkType: 'checkByUid',
        checkFun: 'taskNotice/getNoticeInfo'
      }
    ],
    headButtons: setCheckButtons(['发布']),
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      messageType: '',
      query: ''
    },
    selectData: [
      {
        key: 'messageType',
        label: '通知类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.messageType
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '标题/内容'
      }
    ],
    rowData: (params) => {
      const list = params.state.taskNotice && params.state.taskNotice.noticeList
      return (list && list.result) || []
    },
    rowTotal: (params) => {
      const list = params.state.taskNotice && params.state.taskNotice.noticeList
      return (list && list.totalSize) || 0
    },
    columns: [
      { prop: 'messageTitle', label: '标题', width: '' },
      { prop: 'messageType', label: '通知类型', width: '' },
      { prop: 'scopename', label: '发布范围', width: '260px' },
      { prop: 'messageContent', label: '内容摘要', width: '500px' },
      {
        prop: 'messageStatus',
        label: '发布状态',
        tag: [
          { type: 'danger', label: '草稿', value: '0' },
          { type: 'success', label: '已发布', value: '1' }
        ]
      },
      { prop: 'personName', label: '发布人', width: '' },
      { prop: 'updateTime', label: '发布时间', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['查看', '编辑', '删除']),
        width: '200px'
      }
    ],
    formParams: {
      messageTitle: '',
      messageType: '',
      messageScopeName: '',
      messageScope: [],
      messageContent: '',
      messageEnclosure: [],
      fileLists: {
        messageEnclosure: []
      },
      messageStatus: '1'
    },
    formRules: {
      messageTitle: [
        {
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        },
        {
          min: 1,
          max: 30,
          message: '长度在 1 到 30 个字符',
          trigger: 'blur'
        }
      ],
      messageType: [
        {
          required: true,
          message: '请选择通知类型',
          trigger: 'blur'
        }
      ],
      messageScopeName: [
        {
          required: true,
          message: '请选择发布范围',
          trigger: 'input'
        }
      ],
      messageContent: [
        {
          required: true,
          message: '请输入内容摘要',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '通知公告信息',
      manualUpload: true,
      bottomButtons: setFormButtons(['取消', '存草稿', '提交']),
      fields: [
        {
          key: 'messageTitle',
          label: '标题',
          type: 'input',
          placeholder: '请输入标题,30字符以内'
        },
        {
          key: 'messageType',
          label: '通知类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.messageType
          }
        },
        {
          key: 'messageScopeName',
          label: '发布范围',
          type: 'input',
          placeholder: '请点击选择',
          inputType: 'textarea',
          autosize: { minRows: 5, maxRows: 7 }
        },
        {
          key: 'messageContent',
          label: '内容摘要',
          type: 'input',
          placeholder: '请输入内容摘要',
          inputType: 'textarea',
          autosize: { minRows: 10, maxRows: 12 }
        },
        {
          key: 'messageEnclosure',
          label: '附件',
          type: 'upload',
          uploadtip: (params) => {
            return params.pageStatus === 'add' || params.pageStatus === 'edit'
              ? '只能添加jpg/png图片文件'
              : params.formValues &&
                params.formValues.fileLists &&
                params.formValues.fileLists.messageEnclosure.length
              ? '点击图片名称可预览查看图片详情'
              : '/'
          }, // 上传提示语
          listType: 'text',
          autoUpload: false
        }
      ]
    }
  }
}
export default notice
